import React from 'react'
// import './EmptyTodos.css';

function EmptyTodos() {

  return (
    <p>Crear tu primer TODO!!</p>
  )
}

export {EmptyTodos};